import {
  uploadFileToS3,
  uploadFileWithMultipart,
  uploadFile,
  shouldUseMultipartUpload,
} from "./s3-upload.service";
import {
  getYouTubeMetadata,
  importFromYouTube,
} from "./youtube-import.service";
import { getRssFeedEpisodes, importFromRss } from "./rss-import.service";

export * from "./s3-upload.service";
export * from "./youtube-import.service";
export * from "./rss-import.service";

export const createEspisodeService = {
  uploadFileToS3,
  uploadFileWithMultipart,
  uploadFile,
  shouldUseMultipartUpload,
  getYouTubeMetadata,
  importFromYouTube,
  getRssFeedEpisodes,
  importFromRss,
};
